import { render } from "./articleLeft.vue?vue&type=template&id=34d8d207&scoped=true"
import script from "./articleLeft.vue?vue&type=script&lang=js"
export * from "./articleLeft.vue?vue&type=script&lang=js"

import "./articleLeft.vue?vue&type=style&index=0&id=34d8d207&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d8d207"]])

export default __exports__